import { render, staticRenderFns } from "./salelist.vue?vue&type=template&id=5957eb30&scoped=true&"
import script from "./salelist.vue?vue&type=script&lang=js&"
export * from "./salelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5957eb30",
  null
  
)

export default component.exports